<template>
    <div class="record-requests">
        <!-- Header -->
        <div class="header">
            <span class="icon"><common-icon name="timer" size="small"></common-icon></span>
            <h5 class="main-title">{{ $t('modals.patient_profile.profile.record_form.head') }}</h5>
        </div>

        <!-- Record Card -->
        <div v-for="request in requests" :key="request.id" class="request-card">
            <div class="main">
                <div class="card-headers">
                    <h3 class="hospital">{{ request.hospital }}</h3>
                    <div class="badges">
                        <!-- Status badge with dynamic icon -->
                        <span :class="['status', request.status.toLowerCase()]">
                            <common-icon :name="request.icon" size="tiny"></common-icon>
                            {{ request.status }}
                        </span>
                        <span v-if="request.network" class="network">{{ request.network }}</span>
                        <span v-if="request.emails" class="email">{{ request.emails }}</span>
                    </div>
                </div>

                <div class="actions">
                    <button class="btn detail" @click="OpenModel()">
                        <common-icon name="view" size="tiny"></common-icon>
                        {{ $t('modals.patient_profile.profile.record_form.button.title') }}
                    </button>
                    <details-model :isOpen="isDetailsModelOpen" @close="closeModal()"></details-model>
                    <button v-if="request.download" class="btn download">
                        <common-icon name="download" size="tiny"></common-icon>
                        {{ $t('modals.patient_profile.profile.record_form.button.downloadtitle') }}
                    </button>
                </div>
            </div>

            <div class="card-body">
                <div class="card_grid">
                    <p>
                        <strong>{{ $t('modals.patient_profile.profile.record_form.request_id.id') }}</strong>
                        {{ request.id }}
                    </p>
                    <p>
                        <strong>{{ $t('modals.patient_profile.profile.record_form.request_id.date') }}</strong>
                        {{ request.date }}
                    </p>
                    <p v-if="request.expected">
                        <strong>{{ $t('modals.patient_profile.profile.record_form.request_id.expected') }}</strong>
                        {{ request.expected }}
                    </p>
                </div>

                <p>
                    <strong>{{ $t('modals.patient_profile.profile.record_form.record.name') }}</strong>
                    {{ request.records }}
                </p>
                <p>
                    <strong>{{ $t('modals.patient_profile.profile.record_form.notes.name') }}</strong>

                    {{ request.notes }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import DetailsModel from 'components/page-elements/patient/DetailsModel'

    export default {
        components: { DetailsModel },
        data() {
            return {
                requests: [
                    {
                        id: 'REQ001',
                        hospital: 'St. Mary’s Hospital',
                        status: 'Pending',
                        icon: 'timer',
                        network: 'Medmatch Network',
                        date: '15/01/2025',
                        expected: '22/01/2025',
                        records: 'Complete Medical History',
                        notes: 'Patient needs records for specialist consultation',
                    },
                    {
                        id: 'REQ002',
                        hospital: 'Downtown Clinic',
                        emails: 'Email Request',
                        status: 'Received',
                        icon: 'download',
                        date: '10/01/2025',
                        records: 'Lab Results',
                        notes: 'Blood work from last month',
                        download: true,
                    },
                    {
                        id: 'REQ003',
                        hospital: 'Jacksonville General Hospital',
                        status: 'Approved',
                        icon: 'check-circle',
                        network: 'Medmatch Network',
                        date: '08/01/2025',
                        expected: '18/01/2025',
                        records: 'Imaging Reports, Consultation Notes',
                        notes: 'MRI and consultation reports needed for ongoing treatment',
                    },
                    {
                        id: 'REQ004',
                        hospital: 'Northeast Mental Health Center',
                        emails: 'Email Request',
                        status: 'Rejected',
                        icon: 'close',
                        date: '05/01/2025',
                        records: 'Mental Health Records',
                        notes: 'Request denied - incomplete authorization form',
                    },
                ],
                isDetailsModelOpen: false,
            }
        },
        methods: {
            OpenModel() {
                this.isDetailsModelOpen = true
            },
            closeModal() {
                this.isDetailsModelOpen = false
            },
        },
    }
</script>

<style scoped>
    .record-requests {
        border: 1px solid #e0e0e0;
        padding: 18px;
        border-radius: 10px;
    }
    .header {
        display: flex;
        margin-bottom: 12px;
    }
    .main-title {
        font-size: 14px;
        font-weight: 400;
        color: #030213;
        margin-left: 10px;
    }
    .request-card {
        border: 1px solid #e0e0e0;
        border-radius: 10px;
        padding: 16px;
        margin-bottom: 16px;
        background: #fff;
    }
    .request-card:hover {
        background-color: oklch(0.985 0.002 247.839);
    }
    .main {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
    }
    .card-headers {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .hospital {
        font-size: 14px;
        font-weight: 400;
        white-space: nowrap;
        color: oklch(0.145 0 0);
        margin-right: 12px;
    }
    .badges {
        display: flex;
        gap: 6px;
        align-items: center;
    }
    .status {
        padding: 2px 8px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 4px;
    }
    .status.pending {
        background: #fff3cd;
        color: #8d6d0c;
    }
    .status.received {
        background: #cce5ff;
        color: oklch(0.424 0.199 265.638);
    }
    .status.approved {
        background: oklch(0.962 0.044 156.743);
        color: oklch(0.448 0.119 151.328);
    }
    .status.rejected {
        background: oklch(0.936 0.032 17.717);
        color: oklch(0.444 0.177 26.899);
    }
    .network {
        border: 1px solid oklch(0.627 0.194 149.214);
        color: oklch(0.627 0.194 149.214);
        font-size: 12px;
        padding: 1px 8px;
        font-weight: 500;
        border-radius: 6px;
    }
    .email {
        color: oklch(0.546 0.245 262.881);
        padding: 2px 8px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 500;
        border: 1px solid oklch(0.546 0.245 262.881);
    }
    .actions {
        display: flex;
        gap: 8px;
    }
    .btn {
        border: none;
        border-radius: 6px;
        padding: 6px 12px;
        cursor: pointer;
        font-size: 13px;
        display: flex;
        align-items: center;
        gap: 6px;
    }
    .btn.detail {
        border: 1px solid #eee;
    }
    .btn.download {
        background: #fff;
        color: oklch(0.546 0.245 262.881);
        border: 1px solid #d1d5db;
    }
    .btn.download:hover {
        color: #030213;
        background: #f0f0f0;
    }
    .card-body {
        margin: 12px 0;
        font-size: 14px;
    }
    .card_grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
    }
    .card-body p {
        margin: 6px 0;
    }
    .card-body p strong {
        color: oklch(0.145 0 0);
        font-size: 14px;
        font-weight: 500;
    }
    @media screen and (max-width: 600px) {
        .card-headers,
        .main {
            display: block !important;
        }
    }
</style>
